"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixTheme = exports.contrastCheck = exports.contrast = exports.luminance = exports.RGBToHex = exports.hexToRGB = exports.Color = void 0;
var default_1 = __importDefault(require("../theme/default"));
var logger_1 = require("./logger");
var minmax = function minmax(value) {
  var lowerBound = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var higherBound = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return Math.max(lowerBound, Math.min(higherBound, value));
};
var round2 = function round2(num) {
  return Math.round((num + Number.EPSILON) * 100) / 100;
};
var Format;
(function (Format) {
  Format[Format["Hex"] = 0] = "Hex";
  Format[Format["Rgb"] = 1] = "Rgb";
})(Format || (Format = {}));
var Color = /*#__PURE__*/function () {
  function Color(color) {
    _classCallCheck(this, Color);
    this.a = null;
    if (color.startsWith('#')) {
      if (color.length === 4) {
        // eg: #fff, #000
        this.r = parseInt(color.slice(1, 2) + color.slice(1, 2), 16);
        this.g = parseInt(color.slice(2, 3) + color.slice(2, 3), 16);
        this.b = parseInt(color.slice(3, 4) + color.slice(3, 4), 16);
      } else {
        // eg: #ffffff, #000000
        this.r = parseInt(color.slice(1, 3), 16);
        this.g = parseInt(color.slice(3, 5), 16);
        this.b = parseInt(color.slice(5, 7), 16);
        if (color.length === 9) {
          // eg: #ffffff80, #000000ff
          this.a = round2(minmax(parseInt(color.slice(7, 9), 16) / 255));
        }
      }
    } else if (color.startsWith('rgb')) {
      // eg: rgb(0, 0, 0)
      var values = color.split('(')[1].split(')')[0].split(',');
      this.r = parseInt(values[0].trim(), 10);
      this.g = parseInt(values[1].trim(), 10);
      this.b = parseInt(values[2].trim(), 10);
      if (values[3]) {
        // eg: rgba(0, 0, 0, 1)
        this.a = round2(minmax(parseFloat(values[3])));
      }
      (0, logger_1.getApplicationLogger)().warn('[colors]', "RGB(A) values not officially supported, but were translated to hex (".concat(color, " -> ").concat(this.toHex(), ")"));
    } else if (color.startsWith('hsl')) {
      // eg: hsl(100, 50%, 75%)
      var _values = color.split('(')[1].split(')')[0].split(',');
      var h = parseInt(_values[0].trim().replace('deg', ''), 10);
      var s = parseInt(_values[1].trim().replace('%', ''), 10);
      var l = parseFloat(_values[2].trim().replace('%', ''));
      if (l > 1) {
        l /= 100;
      }
      var a = s * Math.min(l, 1 - l) / 100;
      var f = function f(n) {
        var k = (n + h / 30) % 12;
        var unroundedColor = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * unroundedColor + Number.EPSILON);
      };
      this.r = f(0);
      this.g = f(8);
      this.b = f(4);
      if (_values[3]) {
        // eg: hsla(100, 50%, 75%, 0.8)
        this.a = round2(minmax(parseFloat(_values[3])));
      }
      (0, logger_1.getApplicationLogger)().warn('[colors]', "HSL(A) values not officially supported, but were translated to hex (".concat(color, " -> ").concat(this.toHex(), ")"));
    } else {
      throw new Error("Malformed color (".concat(color, ")"));
    }
  }
  _createClass(Color, [{
    key: "opacity",
    value: function opacity(alpha) {
      if (alpha != null) {
        this.a = round2(minmax(alpha));
      }
      return this;
    }
  }, {
    key: "toRGB",
    value: function toRGB() {
      if (this.a !== null) {
        return "rgba(".concat(this.r, ", ").concat(this.g, ", ").concat(this.b, ", ").concat(this.a, ")");
      }
      return "rgb(".concat(this.r, ", ").concat(this.g, ", ").concat(this.b, ")");
    }
  }, {
    key: "toHex",
    value: function toHex() {
      var hex = [this.r.toString(16).padStart(2, '0'), this.g.toString(16).padStart(2, '0'), this.b.toString(16).padStart(2, '0')].join('');
      if (this.a !== null) {
        // 0 <= this.a <= 1
        var alpha = Math.round(this.a * 256).toString(16).padStart(2, '0');
        return "#".concat(hex).concat(alpha);
      }
      return "#".concat(hex);
    }
  }, {
    key: "toString",
    value: function toString(format) {
      switch (format) {
        case Format.Hex:
          return this.toHex();
        case Format.Rgb:
          return this.toRGB();
      }
    }
  }]);
  return Color;
}();
exports.Color = Color;
function hexToRGB(hex, alpha) {
  return new Color(hex).opacity(alpha).toRGB();
}
exports.hexToRGB = hexToRGB;
function RGBToHex(rgba) {
  return new Color(rgba).toHex();
}
exports.RGBToHex = RGBToHex;
// https://en.wikipedia.org/wiki/Relative_luminance#Relative_luminance_and_.22gamma_encoded.22_colorspaces
function luminance(color) {
  var a = [color.r, color.g, color.b].map(function (v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
exports.luminance = luminance;
function contrast(a, b) {
  var lum1 = luminance(a);
  var lum2 = luminance(b);
  var brightest = Math.max(lum1, lum2);
  var darkest = Math.min(lum1, lum2);
  return round2((brightest + 0.05) / (darkest + 0.05));
}
exports.contrast = contrast;
function contrastCheck(theme) {
  // minimal recommended contrast ratio is 4.
  // or 3 for larger font-sizes
  var textToBg = contrast(new Color(theme.background), new Color(theme.text));
  if (textToBg <= 4) {
    (0, logger_1.getApplicationLogger)().warn('[colors]', "Potential accessibility issue between text and background colors (".concat(textToBg, ")"));
  }
  var textSecondaryToBg = contrast(new Color(theme.background), new Color(theme.textSecondary));
  if (textSecondaryToBg <= 4) {
    (0, logger_1.getApplicationLogger)().warn('[colors]', "Potential accessibility issue between textSecondary and background colors (".concat(textSecondaryToBg, ")"));
  }
  var primaryToSecondary = contrast(new Color(theme.background), new Color(theme.secondary));
  if (primaryToSecondary <= 3) {
    (0, logger_1.getApplicationLogger)().warn('[colors]', "Potential accessibility issue between primary and secondary colors (".concat(primaryToSecondary, ")"));
  }
}
exports.contrastCheck = contrastCheck;
function fixTheme(theme) {
  Object.entries(theme).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (!(key in default_1.default.light)) {
      (0, logger_1.getApplicationLogger)().error('[colors]', "Theme key ".concat(key, " is not valid."));
    }
    var _key = key;
    try {
      var color = new Color(value);
      theme[_key] = color.toHex();
    } catch (e) {
      theme[_key] = '#FF0000';
      (0, logger_1.getApplicationLogger)().error('[colors]', "Could not parse theme. ".concat(_key, " with value ").concat(value, ". Replaced it with red!"));
    }
  });
}
exports.fixTheme = fixTheme;